import { customFetch } from "./baseService"

const authService = {
  login: (credentials) => {
    return customFetch('auth/login',{
      method: 'POST',
      body: credentials,
    })
  },

  register: (userData) => {
    return customFetch('auth/register',{
      method: 'POST',
      body: userData,
    })
  }
}

export default authService
